import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initLenis, destroyLenis } from './lib/lenis';
import { initCardGlow } from './lib/cardGlow';
import Navbar from './Components/Navbar.jsx';
import Education from './Components/Education.jsx';
import Experience from './Components/Experience.jsx';
import Skills from './Components/Skills.jsx';
import Projects from './Components/Projects/Projects.jsx';
import ContactMe from './Components/ContactMe.jsx';
import About from './Components/About.jsx';
import FullPageScrubVideo from './Components/FullPageScrubVideo.jsx';
import ScrollProgressDots from './Components/ScrollProgressDots.jsx';
import journey from './Assets/Videos/journey.mp4';
import keyframe1 from './Assets/Videos/keyframe1.jpg';

function App() {
  useEffect(() => {
    initLenis();
    const removeCardGlow = initCardGlow();
    return () => {
      destroyLenis();
      removeCardGlow?.();
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
    <div className='overflow-x-hidden min-h-screen text-slate-300 antialiased selection:bg-biolum-green selection:text-ocean-dark'>
      <FullPageScrubVideo src={journey} poster={keyframe1} />
      <ScrollProgressDots />

      <div id="about" className='container px-4 lg:px-8 pt-24 mx-auto relative z-10'>
        <Navbar />
        <About />
        <Experience />
        <Education />
        <Projects />
        <Skills />
        <ContactMe />
      </div>
    </div>
    </MotionConfig>
  );
}

export default App;
